import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'Helpers/PropTypes';

import 'Assets/Css/font-awesome.min.css';

class FontAwesome extends Component {
  constructor(props) {
    super(props);

    this.getStyle = this.getStyle.bind(this);
  }

  getStyle() {
    // TODO: We should just use style but leaving this for backward compatiblity
    const { fontSize, style } = this.props;
    const newStyle = { ...style };
    if (fontSize) {
      newStyle.fontSize = fontSize;
    }
    return newStyle;
  }

  render() {
    const {
      icon,
      onMouseEnter,
      onMouseLeave,
      onFocus,
      className,
      test,
      onClick,
    } = this.props;
    return (
      <i
        role="presentation"
        className={`fa fa-${icon}${className ? ` ${className}` : ''}`}
        style={this.getStyle()}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onFocus={onFocus}
        onClick={onClick}
        test={test}
      />
    );
  }
}

FontAwesome.propTypes = {
  className: PropTypes.string,
  fontSize: PropTypes.string,
  icon: PropTypes.string.isRequired,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onFocus: PropTypes.func,
  style: PropTypes.instanceOf(Object),
  test: PropTypes.string,
  onClick: PropTypes.func,
};

FontAwesome.defaultProps = {
  className: '',
  fontSize: null,
  onMouseEnter: noop,
  onMouseLeave: noop,
  onFocus: noop,
  style: {},
  test: '',
  onClick: undefined,
};

export default FontAwesome;
